
define('text!widgets/casumoHoldingValuables/view.html',[],function () { return '<div class="casumo-holding-valuables" data-bind="style.width: width">\n    <ul class="valuables" data-bind="foreach: valuables">\n        <li><img src="{{ imageUrl }}" /></li>\n    </ul>\n</div>\n';});

